<template lang="pug">
  v-flex(xs12)
    v-container.py-0.elevation-1.white(fluid)
    v-container(fluid grid-list-lg :class="{'pt-0': modalView, 'pb-0': modalView }")
      v-layout(fill-height row-wrap)
        v-snackbar(v-model="handleError" color="error")
          div {{ errorMessage }}
        v-snackbar(v-model="handleSuccess" color="success")
          div {{ successMessage }}
        v-layout(wrap)
          v-flex(xs12 ml-2)
            action-title-bar(v-if="!modalView" title="lite brand registration for a2p 10dlc" data-cy="title-bar")
          v-flex(:class="{'xs7': !modalView, 'offset-xs2':!modalView}")
            v-card
              v-card-text
                v-form(
                  ref="form"
                  v-model="valid"
                )
                  v-flex(xs12)
                    v-layout.row-title(wrap)
                      v-flex(xs12)
                        h3 General Information
                    v-layout(wrap)
                      v-flex(xs6)
                            v-text-field(
                              label="First Name*",
                              v-model="form.firstName"
                              :rules="[rules.required]"
                              browser-autocomplete="disable"
                              required
                            )
                      v-flex(xs6)
                            v-text-field(
                              label="Last Name*"
                              v-model="form.lastName"
                              :rules="[rules.required]"
                              browser-autocomplete="disable"
                              required
                            )
                  v-flex(xs12)
                    v-layout(wrap)
                      v-flex(xs6)
                        v-text-field(
                          label="Email*",
                          v-model="form.email"
                          :rules="[rules.email]"
                          required
                        )
                      v-flex(xs6)
                        v-text-field(
                          label="Main Contact # (Cell/Work)*"
                          v-model="form.phone"
                          :rules="[rules.phone]"
                          browser-autocomplete="disable"
                          required
                        )
                  v-flex(xs12)
                    v-layout.row-title(wrap)
                      v-flex(xs12)
                        h3 Billing physical address (PO Box address is not accepted)
                          v-tooltip(bottom max-width="250px")
                            template(slot="activator")
                              v-icon(small) info
                            span {{ addressPOBoxMessage }}
                    v-layout(wrap)
                      v-flex(xs12)
                        v-layout(row wrap)
                          v-flex(xs4)
                            v-text-field(
                              label="Street*"
                              v-model="form.street"
                              :rules="[rules.required, rules.address]"
                              browser-autocomplete="disable"
                              required
                            )
                          v-flex(xs4)
                            v-text-field(
                              v-if="form.country === 'US'"
                              label="Zip Code*"
                              v-model="form.zipCode"
                              :rules="[rules.required, rules.zipCode]"
                              browser-autocomplete="disable"
                              mask="#####"
                              required
                            )
                            v-text-field(
                              v-else
                              label="Zip Code*"
                              v-model="form.zipCode"
                              :rules="[rules.required]"
                              browser-autocomplete="disable"
                              required
                            )
                          v-flex(xs4)
                            v-text-field(
                              label="City*"
                              v-model="form.city"
                              :rules="[rules.required]"
                              browser-autocomplete="disable"
                              required
                            )
                        v-layout(wrap)
                          v-flex(xs12)
                            v-layout( wrap)
                              v-flex(xs4)
                                v-select(
                                  label="Country*"
                                  v-model="form.country"
                                  :rules="[rules.required]"
                                  browser-autocomplete="disable"
                                  :items="countries"
                                  item-text="text"
                                  item-value="value"
                                  @change="onCountryChange"
                                  required
                                )
                              v-flex(xs4)
                                v-autocomplete(
                                  label="State/Province/Region*"
                                  v-model="form.state"
                                  :rules="[rules.required]"
                                  browser-autocomplete="disable"
                                  :items="states"
                                  item-text="text"
                                  item-value="value"
                                  required
                                )
                  v-flex(xs12)
                    v-layout.row-title(wrap)
                      v-flex(xs12)
                        h3 Business information
                    v-layout(wrap)
                      v-flex(xs6)
                        v-text-field(
                          label="Business Name*",
                          v-model="form.brokerage"
                          browser-autocomplete="disable"
                          :rules="[rules.required]"
                          required
                        )
                      v-flex(xs6)
                        v-select(
                          label="Team size"
                          :items="teamSize"
                          v-model="form.teamSize"
                          browser-autocomplete="disable"
                        )
                    v-layout.row-copy(wrap)
                      v-flex(xs12)
                        span As a sole proprietor, the legal name of your business is your pesonal name or your public DBA.
                  v-flex(
                    :class="{'mt-5': !modalView, 'mb-5':!modalView}"
                  ).actions.xs12
                      v-btn(
                        color="primary"
                        data-cy="next-campaign-step"
                        :disabled="shouldDisableSubmitBtn"
                        @click="save"
                      ) Submit
</template>
<script>
import ActionTitleBar from '@/Core/components/ActionTitleBar';
import { mapActions, mapMutations, mapState } from "vuex";

import {
  EMAIL_REGEX,
  PHONE_WITHOUT_COUNTRY_REGEX,
  US_ZIP_CODE_REGEX,
  ADDRESS_PO_BOX_REGEX,
} from "@/Core/config/regex";

import {
  STATES_CA,
  STATES_US
} from "../config/states";

import {
  ADDRESS_PO_BOX_MESSAGE,
  COUNTRIES,
  TEAM_SIZE
} from "../config";


export default {
  name: 'RegisterCustomerLiteForm',
  components: {
    ActionTitleBar
  },
  props: {
    modalView: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (!this.user) {
      this.getUser();
    }
  },
  data() {
    return {
      valid: true,
      disableSubmitBtn: false,
      form: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        street: null,
        zipCode: null,
        city: null,
        country: null,
        state: null,
        brokerage: null,
        teamSize: null,
      },
      rules: {
        required: value => {
          return !!value || 'This field is required'
        },
        email: value => {
          return EMAIL_REGEX.test(value) || 'Invalid Email address'
        },
        phone: value => {
          return PHONE_WITHOUT_COUNTRY_REGEX.test(value) || 'Invalid phone number';
        },
        address: value => {
          return !ADDRESS_PO_BOX_REGEX.test(value) || 'P.O. Box addresses are not accepted'
        },
        zipCode: value => {
          return US_ZIP_CODE_REGEX.test(value) || 'Invalid zip code';
        },
      },
      countries: COUNTRIES,
      statesCA: STATES_CA,
      statesUS: STATES_US,
      teamSize: TEAM_SIZE,
      addressPOBoxMessage: ADDRESS_PO_BOX_MESSAGE,
    }
  },
  computed: {
    ...mapState('registerLiteCustomerA2p', [
      'error',
      'success',
      'errorMessage',
      'successMessage',
      'isLoading',
    ]),
    ...mapState('userInformation', ['user']),
    states() {
      if (!this.form.country) return [];
      if (this.form.country === 'US') {
        return this.statesUS;
      }
      return this.statesCA;
    },
    handleError: {
      get() {
        return this.error;
      },
      set() {
        this.resetError();
      }
    },
    handleSuccess: {
      get() {
        return this.success;
      },
      set() {
        this.resetSuccess();
      }
    },
    shouldDisableSubmitBtn() {
      return this.disableSubmitBtn || !this.valid || this.isLoading;
    },
  },
  methods: {
    ...mapMutations('registerLiteCustomerA2p', [
      'setForm',
      'resetError',
      'resetSuccess'
    ]),
    ...mapActions('registerLiteCustomerA2p', [
      'saveLiteCustomer'
    ]),
    ...mapActions( 'userInformation', [
      'getUser'
    ]),
    async save() {
      try {
        if (this.$refs.form.validate()) {
          this.setForm({form: this.form});
          await this.saveLiteCustomer();
        }
      } catch (error) {
      } finally {
        if (this.modalView) {
          this.$emit('submit', true);
        }
      }
    },
    onCountryChange() {
      const { zipCode } = this.form;
      if (!zipCode || zipCode.length === 0) return;
      this.form.zipCode = '';
    },
  },
  watch: {
    success: {
      handler(value){
        if (value) {
          this.disableSubmitBtn = true;
          return;
        }

        if (!this.modalView) {
          this.$router.back();
        }
      }
    },
    error: {
      handler(value){
        if (value) {
          this.disableSubmitBtn = false;
        };
      }
    },
    user: {
      handler(value){
        if (value){
          this.form.firstName = value.first_name;
          this.form.lastName = value.last_name;
          this.form.email = value.email;
        }
      }
    }
  }
}
</script>
<style scoped>

h3 {
  font-size: 14px !important;
}

.actions{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.row-title {
  margin-bottom: -16px !important;
}

.row-copy {
  margin-top: -24px !important;
  font-size: 12px !important;
  opacity: 0.54;
}
</style>
